

















import { Component, Vue } from 'vue-property-decorator'
import ffButton from '@/components/public/Button.vue'
import User from '@/components/public/User.vue'
import { namespace } from 'vuex-class'

const appStore = namespace('app')

@Component({
  components: {
    ffButton,
    User
  }
})
export default class Layout extends Vue {
  isSignIn = false
  isInit = false
  @appStore.State(state => state.isLogin) isLogin: boolean
  @appStore.State(state => state.fullscreenLoading) fullscreenLoading: boolean
  @appStore.State(state => state.authMethod) authMethod: number
  @appStore.Action('loginIn') loginIn: Function
  handleLogin () {
    if (this.authMethod === 0) {
      const idToken = 'testidtoken'
      this.loginIn(idToken)
    } else {
      this.googleLogin()
    }
  }
  async googleLogin () {
    try {
      const googleUser = await this['$gAuth'].signIn()
      if (!googleUser) {
        return null
      }
      const { id_token: idToken } = googleUser.getAuthResponse()
      this.loginIn(idToken)
    } catch (error) {
      console.log(error)
      return null
    }
  }
  initStatus (): void {
    if (this.authMethod === 0) {
      this.isInit = true
    } else {
       const checkGauthLoad = setInterval(() => {
        this.isInit = this['$gAuth'].isInit
        this.isSignIn = this['$gAuth'].isAuthorized
        if (this.isInit) clearInterval(checkGauthLoad)
      }, 1000)
    }
  }
  created (): void {
    this.initStatus()
  }
}
